import React from "react"
import { Box, Center, Heading, VStack } from "@chakra-ui/layout"

import ResponsiveBlock from "~components/shared/layout/responsive-block"
import { CompetitorCopy } from "./resources/_copy-template"
import Paragraph from "~components/shared/text/paragraph"
import BookADemoButton from "~components/shared/book-a-demo-button"

interface Props {
    copy: CompetitorCopy["landing"]
}

export default function ComparisonParagraph({ copy }: Props) {
    return (
        <ResponsiveBlock>
            <Box maxW="724px" margin="auto" my={24}>
                <VStack spacing={6} alignItems="flex-start">
                    <Heading color="navy.700" fontWeight="extrabold">
                        {copy.tagline}
                    </Heading>
                    {copy.paragraph.map((text, index) => (
                        <Paragraph key={index} textAlign="left">
                            {text}
                        </Paragraph>
                    ))}
                    <Center w="full">
                        <BookADemoButton rounded="full" />
                    </Center>
                </VStack>
            </Box>
        </ResponsiveBlock>
    )
}
